import { safeParse } from "@/utils/safeParse";
import { useMemoizedFn, useSafeState } from "ahooks";
import Cookies from "js-cookie";
import { omit } from "lodash";
import { useMemo } from "react";
export default function useCookieState(cookieKey, option) {
  const [state, setState] = useSafeState(
    Cookies.get(cookieKey) || option.defaultValue
  );

  const changeState = useMemoizedFn((value) => {
    if (typeof value === "object") {
      value = encodeURIComponent(JSON.stringify(value));
    }
    Cookies.set(cookieKey, value, omit(option, ["defaultValue"]));
    setState(value);
  });

  const deserializationValue = useMemo(() => {
    if (typeof state === "string") {
      return safeParse(decodeURIComponent(state), () => state);
    }
    return state;
  }, [state]);

  // const onChangePath = useMemoizedFn(() => {
  //   const nextValue = Cookies.get(cookieKey) || option.defaultValue;
  //   console.log("onChangeKey - nextValue", nextValue)
  //   changeState(nextValue);
  //   option?.onChangePath && option?.onChangePath(nextValue);
  // });

  // useEffect(() => {
  //   onChangePath();
  // }, [option?.path, onChangePath]);

  return [deserializationValue, changeState];
}
